import React, {useState} from 'react'
import {
  NoResults,
  useLocationCheckpoints,
  useLocationContext,
  usePaginationState,
} from '@therms/react-modules'
import {Card, Icon, Pagination} from '@therms/atalaya'
import {CheckpointDetailModal} from '../CheckpointDetailModal'
import {MdNfc, MdOutlineQrCode} from 'react-icons/md'

function CheckpointsList() {
  const {locationId} = useLocationContext(true)
  const {recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords} =
    usePaginationState('locchklst', {}, [])
  const [showCheckpointModal, setShowCheckpointModal] = useState('')

  const {data} = useLocationCheckpoints({locationId})

  return (
    <div>
      <div className="gap-y-xs flex flex-col">
        {data?.checkpoints.map((checkpoint) => (
          <Card
            key={checkpoint.id}
            padding="xs"
            space="xs"
            onClick={() => setShowCheckpointModal(checkpoint.id)}
          >
            <div>
              <span className="uppercase">
                <Icon
                  className="mr-xs"
                  Icon={checkpoint.type === 'qr' ? MdOutlineQrCode : MdNfc}
                />
                <span className="text-color-neutral-faded font-light">
                  {checkpoint.type}{' '}
                </span>
              </span>
              {checkpoint.name}
            </div>
            <div className="border-border border-t" />
            <div className="text-color-neutral">{checkpoint.description}</div>
          </Card>
        ))}
      </div>

      {data?.checkpoints.length ? (
        <Pagination
          onPageClick={setSkippedRecords}
          onSetRecordsPerPage={setRecordsPerPage}
          recordsPerPage={recordsPerPage}
          showDescription
          skippedRecords={skippedRecords}
          totalRecords={data?.total}
        />
      ) : (
        <NoResults text="No Checkpoints" />
      )}

      {!!showCheckpointModal && (
        <CheckpointDetailModal
          checkpointId={showCheckpointModal}
          onClose={() => setShowCheckpointModal('')}
        />
      )}
    </div>
  )
}

export {CheckpointsList}
